import React, { useEffect, useState } from 'react';
import TabPanel from '../../quickcheck/share/tab_panel';
import Actions from '../../../actions/actions';
import { TabSwapWarningContext } from './tab_swap_warning_context';
import { Paper, Tab, Tabs } from '@mui/material';
/*
  should take in an array formatted as below:
  [ {label, idName, route, content} ]
 */

const TabManager = ({ tabArray, shownTabs, startingTab, idParam }) => {
  const [changeDialogContext, setChangeDialogContext] = useState({});

  let i = 0;
  tabArray = tabArray.filter((tab) => {
    if (shownTabs.some((tabToCheck) => tabToCheck === tab.label)) {
      tab.index = i++;
      return true;
    }
    return false;
  });

  const [currentStep, setCurrentStep] = useState(tabArray.findIndex((a) => a.label === startingTab));

  /* eslint-disable  react-hooks/exhaustive-deps */
  useEffect(() => {
    const tabIndex = tabArray.findIndex((a) => a.label === startingTab);
    setCurrentStep(tabIndex);
    if (tabArray[tabIndex].onMount) {
      tabArray[tabIndex].onMount();
    }
  }, [startingTab]);
  /* eslint-enable  react-hooks/exhaustive-deps */

  async function onChangeTab(data, rowMeta) {
    let clickedLabel = data?.target?.innerText?.toLowerCase();
    let tabToClick = tabArray.find((t) => t?.label?.toLowerCase() === clickedLabel);

    if (!changeDialogContext.isChanges || changeDialogContext.displayDialog) {
      setCurrentStep(rowMeta);
      setChangeDialogContext({
        ...changeDialogContext,
        displayDialog: false,
        isChanges: false,
      });
      Actions.setRoute(tabArray[rowMeta].route);
      tabToClick.onClick();
    } else {
      await setChangeDialogContext({
        ...changeDialogContext,
        displayDialog: true,
        confirmTabSwap: () => {
          confirmTabSwap(data, rowMeta);
          tabToClick.onClick();
        },
      });
    }
  }

  function confirmTabSwap(data, rowMeta) {
    setChangeDialogContext({
      ...changeDialogContext,
      isChanges: false,
      displayDialog: false,
    });

    setCurrentStep(rowMeta);
    Actions.setRoute(tabArray[rowMeta].route);
  }

  return (
    <>
      <TabSwapWarningContext.Provider value={{ changeDialogContext, setChangeDialogContext }}>
        <Paper id={idParam}>
          <Tabs value={currentStep} onChange={onChangeTab} indicatorColor="primary" textColor="primary" centered>
            {!!tabArray &&
              tabArray.map((tab) => (
                <Tab className={'qa-generic-tab'} id={tab.idName} label={tab.label} key={tab.index} />
              ))}
          </Tabs>
        </Paper>
        {!!tabArray &&
          tabArray.map((tab) => (
            <TabPanel className="tab-content-area" value={currentStep} index={tab.index} key={tab.index}>
              {tab.content}
            </TabPanel>
          ))}
      </TabSwapWarningContext.Provider>
    </>
  );
};

export default TabManager;
